'use client';

import React from 'react';

import { cn } from '@/app/lib/utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';

type PopupPosition = 'top' | 'right' | 'bottom' | 'left' | '';

interface PopupProps {
  content: string;
  position?: PopupPosition;
  className?: string;
  onClose: () => void;
  isOpen: boolean;
}

const baseWrapperClasses =
  'relative z-10 w-[390px] p-[18px] pr-[44px] border border-[var(--color-secondary-50)] bg-white transition-opacity duration-300 ease-in-out max-[992px]:max-w-[calc(100vw-3rem)]';

const arrowBaseClasses = "before:absolute before:content-[''] before:w-0 before:h-0 before:z-0";

const arrowPositionClasses: Record<PopupPosition, string> = {
  '': 'before:top-[20%] before:right-full before:border-t-[10px] before:border-b-[10px] before:border-t-transparent before:border-b-transparent before:border-r-[10px] before:border-r-white before:[filter:drop-shadow(-1px_0px_0px_var(--color-secondary-50))]',
  top: 'before:top-[-10px] before:left-[20%] before:right-auto before:border-l-[10px] before:border-r-[10px] before:border-l-transparent before:border-r-transparent before:border-b-[10px] before:border-b-white before:[filter:drop-shadow(0px_-1px_0px_var(--color-secondary-50))]',
  right:
    'before:top-[20%] before:left-full before:right-auto before:border-t-[10px] before:border-b-[10px] before:border-t-transparent before:border-b-transparent before:border-l-[10px] before:border-l-white before:[filter:drop-shadow(1px_0px_0px_var(--color-secondary-50))]',
  bottom:
    'before:bottom-[-10px] before:left-[20%] before:top-auto before:border-l-[10px] before:border-r-[10px] before:border-l-transparent before:border-r-transparent before:border-t-[10px] before:border-t-white before:[filter:drop-shadow(0px_1px_0px_var(--color-secondary-50))]',
  left: 'before:top-[20%] before:right-full before:border-t-[10px] before:border-b-[10px] before:border-t-transparent before:border-b-transparent before:border-r-[10px] before:border-r-white before:[filter:drop-shadow(-1px_0px_0px_var(--color-secondary-50))]',
};

export function PopupInformation({ content, className, onClose, isOpen, position = '' }: PopupProps) {
  const arrowClasses = arrowPositionClasses[position] ?? arrowPositionClasses[''];

  return (
    <div
      className={cn(
        baseWrapperClasses,
        arrowBaseClasses,
        arrowClasses,
        isOpen ? 'opacity-100 visible' : 'opacity-0 invisible',
        className,
      )}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute top-[22px] right-[18px] cursor-pointer text-[#666] transition-colors duration-200 hover:text-[#333]"
      >
        <Icon name="CloseBtn" size={14} />
      </button>
      <Typography variant="bodyMd">{content}</Typography>
    </div>
  );
}
